import { render, staticRenderFns } from "./PartnerProfile.vue?vue&type=template&id=f233fee4&scoped=true&"
import script from "./PartnerProfile.vue?vue&type=script&lang=js&"
export * from "./PartnerProfile.vue?vue&type=script&lang=js&"
import style0 from "./PartnerProfile.vue?vue&type=style&index=0&id=f233fee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f233fee4",
  null
  
)

export default component.exports